import React from 'react';
import PropTypes from 'prop-types';

class AnnualDiscount extends React.Component {
    render() {
        let planTotal = this.props.promo.price + (this.props.planAddOns * this.props.promo.addOnPrice),
            mainCopy = '',
            constants = this.props.app.config.constants,
            planName = (this.props.user.detail.pubLevel === constants.PUB_LEVEL_6) ? 'Pro' : 'Plus';

        if (this.props.planTweets !== undefined) {
            planTotal += (this.props.planTweets * this.props.promo.tweetPrice);
        }

        mainCopy = (this.props.planAddOns || this.props.planTweets) ? `One year of ${planName} with your current add ons for $${planTotal}` : `One year of ${planName} for just $${this.props.promo.price}`;

        return (
            <div className="promo-content">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <div className="main-copy">
                    {mainCopy}
                </div>
                <div className="sub-copy">
                    Lock in our best available price. Limited time offer.
                </div>
                <div className="promo-action-button" role="button" aria-label="Claim the deal"  onClick={this.props.onRedeemPromoClick}>
                    {this.props.isWorking ? (
                        <span>
                            <i className="fa fa-spinner fa-spin"></i>
                        </span>
                    ) : 'Get our best price'}
                </div>
                <div className="last-chance">
                    {`Add 12 months to your current plan for just $${planTotal} today`}
                </div>
                <div className="coming-soon">
                    <h3>Hands-Free Social Media Publishing</h3>
                    <div className="feature-list">
                        {this.props.features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature-detail">
                                    <div className="feature-image">
                                        <img src={feature.image}/>
                                    </div>
                                    <div className="feature-name">
                                        {feature.label}
                                    </div>
                                    <div className="feature-desc">
                                        {feature.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

AnnualDiscount.displayName = "AnnualDiscount";

AnnualDiscount.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.object
    ]),
    promo: PropTypes.object,
    onRedeemPromoClick: PropTypes.func,
    features: PropTypes.array,
    planAddOns: PropTypes.number
};

AnnualDiscount.defaultProps = {
    image: null,
    promo: null,
    onRedeemPromoClick: () => {},
    features: [],
    planAddOns: 0
};

export default AnnualDiscount;
